import { Checkbox as MantineCheckbox } from '@mantine/core';
import { Check } from 'lucide-react';

export const Checkbox = MantineCheckbox.extend({
	defaultProps: {
		variant: 'primary',
		icon: (props) => <Check {...props} />,
	},
});
